var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoctor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41406 2.73631V1.86569C5.41406 1.66378 5.57784 1.5 5.77975 1.5C5.98166 1.5 6.14545 1.66378 6.14545 1.86569V2.73631C6.14535 2.93815 5.98161 3.1015 5.77975 3.1015C5.5779 3.1015 5.41415 2.93815 5.41406 2.73631Z",
    fill: "#3F8CFF",
    stroke: "#3F8CFF",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.80469 2.73631V1.86569C2.80469 1.66378 2.96847 1.5 3.17038 1.5C3.37229 1.5 3.53607 1.66378 3.53607 1.86569V2.73631C3.53598 2.93815 3.37223 3.1015 3.17038 3.1015C2.96853 3.1015 2.80478 2.93815 2.80469 2.73631Z",
    fill: "#3F8CFF",
    stroke: "#3F8CFF",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 4.91455V3.17381C1.5 2.846 1.63032 2.53142 1.86212 2.29962C2.09392 2.06782 2.4085 1.9375 2.73631 1.9375H3.17137L3.24481 1.94515C3.41151 1.97916 3.53706 2.12645 3.53706 2.30319C3.53706 2.47993 3.41151 2.62722 3.24481 2.66123L3.17137 2.66888H2.73631C2.60242 2.66888 2.47397 2.72211 2.37929 2.81679C2.28461 2.91147 2.23138 3.03992 2.23138 3.17381V4.91455L2.23393 5.02574C2.26143 5.58087 2.49393 6.1079 2.88881 6.50278C3.30998 6.92395 3.88143 7.16021 4.47705 7.16021C5.07266 7.16021 5.64412 6.92395 6.06528 6.50278C6.46017 6.1079 6.69267 5.58087 6.72016 5.02574L6.72271 4.91455V3.17381C6.72271 3.03992 6.66948 2.91147 6.5748 2.81679C6.48012 2.72211 6.35168 2.66888 6.21778 2.66888H5.78273C5.58082 2.66888 5.41704 2.5051 5.41704 2.30319C5.41704 2.10128 5.58082 1.9375 5.78273 1.9375H6.21778C6.5456 1.9375 6.86017 2.06782 7.09198 2.29962C7.32378 2.53142 7.4541 2.846 7.4541 3.17381V4.91455L7.45053 5.06195C7.41408 5.79782 7.10539 6.496 6.58194 7.01944C6.02366 7.57773 5.26658 7.8916 4.47705 7.8916C3.68751 7.8916 2.93044 7.57773 2.37215 7.01944C1.84871 6.496 1.54002 5.79782 1.50357 5.06195L1.5 4.91455Z",
    fill: "#3F8CFF",
    stroke: "#3F8CFF",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.10938 7.52293C4.10937 7.32102 4.27316 7.15724 4.47507 7.15724C4.65181 7.15724 4.7991 7.28279 4.83311 7.44949L4.84076 7.52293C4.84076 8.11855 5.07703 8.69 5.49819 9.11117C5.91935 9.53233 6.49081 9.7686 7.08642 9.7686C7.68204 9.7686 8.2535 9.53233 8.67466 9.11117C9.06954 8.71628 9.30204 8.18925 9.32954 7.63412L9.33209 7.52293V6.21725C9.33209 6.01534 9.49587 5.85156 9.69778 5.85156C9.89969 5.85156 10.0635 6.01534 10.0635 6.21725V7.52293L10.0599 7.67033C10.0235 8.4062 9.71477 9.10438 9.19132 9.62783C8.63303 10.1861 7.87596 10.5 7.08642 10.5C6.29689 10.5 5.53981 10.1861 4.98153 9.62783C4.45808 9.10438 4.14939 8.4062 4.11295 7.67033L4.10938 7.52293Z",
    fill: "#3F8CFF",
    stroke: "#3F8CFF",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2022 5.34569C10.2022 5.06692 9.976 4.84085 9.69725 4.84076C9.41842 4.84076 9.19232 5.06686 9.19232 5.34569C9.19241 5.62444 9.41848 5.85062 9.69725 5.85062C9.97594 5.85053 10.2021 5.62438 10.2022 5.34569ZM10.9331 5.34569C10.933 6.0282 10.3798 6.5814 9.69725 6.58149C9.01466 6.58149 8.46103 6.02826 8.46094 5.34569C8.46094 4.66304 9.0146 4.10938 9.69725 4.10938C10.3798 4.10947 10.9331 4.6631 10.9331 5.34569Z",
    fill: "#3F8CFF",
    stroke: "#3F8CFF",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctor);
export default __webpack_public_path__ + "static/media/doctor.8fd9414fa286dba3ab27b51813be81c4.svg";
export { ForwardRef as ReactComponent };